import { isAxiosError, isAxiosErrorWithResponse } from '../axiosHelpers';
import { isNil } from '../isNil';
import { isObject } from '../object';
// Error Parsers
export class UnknownErrorParser {
  canParse(error) {
    return !isAxiosError(error) || isAxiosError(error) && error.response === undefined;
  }
  parse(error) {
    return {
      type: 'ERROR_UNKNOWN',
      originalError: error
    };
  }
}
export class ValidationDTOErrorParser {
  canParse(error) {
    return isAxiosErrorWithResponse(error) && this.isErrorValidationDTO(error.response.data);
  }
  parse(error) {
    if (!this.canParse(error)) {
      throw new Error('Cannot parse error that does not match ValidationDTOErrorParser criteria');
    }
    const axiosError = error;
    const {
      status,
      statusText,
      data
    } = axiosError.response;
    return {
      type: 'ERROR_RESPONSE_WITH_VALIDATION_DTO',
      status,
      statusText,
      payload: data
    };
  }
  isErrorValidationDTO(payload) {
    return isObject(payload) && 'globalErrors' in payload && Array.isArray(payload.globalErrors);
  }
}
export class PayloadErrorParser {
  canParse(error) {
    return isAxiosErrorWithResponse(error) && !isNil(error.response.data);
  }
  parse(error) {
    if (!this.canParse(error)) {
      throw new Error('Cannot parse error that does not match PayloadErrorParser criteria');
    }
    const axiosError = error;
    const response = axiosError.response;
    const {
      status,
      statusText,
      data
    } = response;
    return {
      type: 'ERROR_RESPONSE_WITH_PAYLOAD',
      status,
      statusText,
      payload: data
    };
  }
}
export class DefaultErrorParser {
  canParse(error) {
    return isAxiosErrorWithResponse(error);
  }
  parse(error) {
    if (!this.canParse(error)) {
      throw new Error('Cannot parse error that does not match DefaultErrorParser criteria');
    }
    const {
      status,
      statusText
    } = error.response;
    return {
      type: 'ERROR_RESPONSE',
      status,
      statusText
    };
  }
}
export class ServerErrorParserFactory {
  parsers = (() => [new UnknownErrorParser(), new ValidationDTOErrorParser(), new PayloadErrorParser(), new DefaultErrorParser()])();
  getParser(error) {
    return this.parsers.find(parser => {
      return parser.canParse(error);
    }) ?? new UnknownErrorParser();
  }
}